import { render, staticRenderFns } from "./FormulaToolbar.vue?vue&type=template&id=70980760"
import script from "./FormulaToolbar.vue?vue&type=script&lang=js"
export * from "./FormulaToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports